document.addEventListener('DOMContentLoaded', () => {
  const promo = document.querySelector('.sticky-promo');
  if (!promo) return;

  const offset = promo.offsetTop;

  window.addEventListener('scroll', () => {
    if (window.scrollY >= offset) {
      promo.classList.add('fixed');
    } else {
      promo.classList.remove('fixed');
    }
  });
});
